export default [
    {
        path: "support-tickets",
        name: "supportTickets",
        component: () =>
            import(
                /* webpackChunkName: "AppErrorlogs" */ "../pages/supportTicket/SupportTicket.vue"
            ),
        meta: {
            title: `Support Tickets`,
        },
    },
    
];